import axiosInstance from './axios-instance';

const getAllRolesByAccountId = async (payload: { accountId: number }) => {
  try {
    const response = await axiosInstance.get(`/roles/get-all?accountId=${payload.accountId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const addNewRole = async (payload: {
  accountId: number;
  name: string;
  items: boolean;
  projects: boolean;
}) => {
  try {
    const response = await axiosInstance.post(`/roles/add`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const editRole = async (payload: {
  accountId: number;
  id: number;
  name?: string;
  items?: boolean;
  projects?: boolean;
}) => {
  try {
    const response = await axiosInstance.put(`/roles/edit`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const deleteRole = async (payload: { accountId: number; id: number }) => {
  try {
    const response = await axiosInstance.delete(
      `/roles/delete?accountId=${payload.accountId}&id=${payload.id}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export { getAllRolesByAccountId, addNewRole, editRole, deleteRole };
